import { Field, FieldFooter, IFormFieldDefaultProps } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { AnyObject } from 'types/util/Object';
import EquipmentAddOnPicker, { IEquipmentAddOnPickerProps } from '../EquipmentAddOnPicker/EquipmentAddOnPicker';

export interface IEquipmentAddOnPickerFormFieldProps<FormType extends AnyObject>
  extends Omit<IEquipmentAddOnPickerProps, 'ids' | 'onChange'>,
    IFormFieldDefaultProps<string[], FormType> {
  onChange?: (values: string[]) => void;
}

function EquipmentAddOnPickerFormField<FormType extends AnyObject>({
  form,
  name,
  validations,
  onChange,
  className,
  revalidateOnNewValidations,
  ...pickerProps
}: IEquipmentAddOnPickerFormFieldProps<FormType>) {
  function renderField({ ...fieldProps }) {
    function handleOnChange(value: string[]) {
      fieldProps.handleChange(value, onChange);
    }

    const currentValue = form.state.data[name] ?? [];

    return (
      <>
        <EquipmentAddOnPicker {...pickerProps} ids={currentValue} onChange={handleOnChange} />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }

  const classes = classNames('equipment-add-on-picker-form-field', className);

  return (
    <Field
      className={classes}
      form={form}
      name={name}
      validations={validations}
      render={renderField}
      revalidateOnNewValidations={revalidateOnNewValidations}
    />
  );
}

export default EquipmentAddOnPickerFormField;
